/* ============================================================
   Kabla · ABC de Drogas — JavaScript vanilla (sin React/bundler)
   Se inicializa sobre cada [data-abc-root] de la página y se
   re-inicializa en el Theme Editor (shopify:section:load).
   Requiere: assets/abc-drugs.js (window.KABLA_ABC_DRUGS)
   ============================================================ */
(function () {
  'use strict';

  var ICONS = {
    search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
    arrow: '<path d="M5 12h14"/><path d="m14 7 5 5-5 5"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    check: '<path d="m5 12 4 4L19 6"/>',
    copy: '<rect x="8" y="8" width="11" height="11" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
    chevron: '<path d="m8 10 4 4 4-4"/>',
    x: '<path d="m7 7 10 10M17 7 7 17"/>',
    menu: '<path d="M4 7h16M4 12h16M4 17h16"/>'
  };
  function icon(name, size) {
    size = size || 20;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[name] + '</svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(t) { return String(t).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSubnav(root) {
  var nav = root.querySelector('.landing-sticky-nav');
  if (!nav) return;

  var extra = Math.max(
    0,
    parseFloat(root.getAttribute('data-sticky-offset')) || 0
  );

  var slot = document.createElement('div');
  slot.className = 'abc-nav-slot';
  nav.parentNode.insertBefore(slot, nav);
  slot.appendChild(nav);
  nav.classList.add('abc-nav-managed');

  var frame = 0;
  var observer;
  var header;

  function headerHeight() {
    header = document.querySelector('.custom-site-nav');
    if (!header) return extra;

    var style = getComputedStyle(header);
    var rect = header.getBoundingClientRect();

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      (style.position !== 'fixed' && style.position !== 'sticky') ||
      rect.bottom <= 0 ||
      rect.top > 1
    ) {
      return extra;
    }

    return Math.ceil(rect.bottom) + extra;
  }

  function targetFor(hash) {
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }

    var target = document.getElementById(id);
    return target && root.contains(target) ? target : null;
  }

  function update() {
    frame = 0;

    var hh = headerHeight();
    var nh = nav.getBoundingClientRect().height;
    var rect = slot.getBoundingClientRect();
    var fixed = rect.top <= hh;

    slot.style.height = nh + 'px';
    root.style.setProperty('--hdr-h', hh + 'px');
    root.style.setProperty('--abc-nav-h', nh + 'px');

    nav.classList.toggle('abc-nav-fixed', fixed);
    root.classList.toggle('nav-merged', fixed);

    if (fixed) {
      var top = Math.min(
        hh,
        root.getBoundingClientRect().bottom - nh
      );

      nav.style.setProperty('--abc-nav-top', top + 'px');
      nav.style.setProperty('--abc-nav-left', rect.left + 'px');
      nav.style.setProperty('--abc-nav-width', rect.width + 'px');
    }

    var links = nav.querySelectorAll('a[href^="#"]');
    var current = null;

    links.forEach(function (link) {
      var target = targetFor(link.hash);
      if (target && target.getBoundingClientRect().top <= hh + nh + 8) {
        current = link;
      }
    });

    links.forEach(function (link) {
      link.classList.toggle('active', link === current);

      if (link === current) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function onClick(event) {
    var link = event.target.closest('a[href^="#"]');

    if (
      !link ||
      link.hash.length < 2 ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    var target = targetFor(link.hash);
    if (!target) return;

    event.preventDefault();

    // El header del tema queda fijo al superar 10 px de scroll.
    var themeHeader = document.querySelector('.custom-site-nav');
    var anticipatedHeight = themeHeader
      ? themeHeader.getBoundingClientRect().height + extra
      : extra;

    window.scrollTo({
      top: Math.max(
        0,
        target.getBoundingClientRect().top +
          window.scrollY -
          anticipatedHeight -
          nav.getBoundingClientRect().height -
          4
      ),
      behavior: reducedMotion ? 'auto' : 'smooth'
    });

    history.replaceState(null, '', link.hash);
  }

  root.addEventListener('click', onClick);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);

  header = document.querySelector('.custom-site-nav');

  if (header && window.MutationObserver) {
    observer = new MutationObserver(schedule);
    observer.observe(header, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  var resizeObserver;
  if (window.ResizeObserver) {
    resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(nav);
    if (header) resizeObserver.observe(header);
  }

  function unload(event) {
    if (!event.target.contains(root)) return;

    cancelAnimationFrame(frame);
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', schedule);
    root.removeEventListener('click', onClick);

    if (observer) observer.disconnect();
    if (resizeObserver) resizeObserver.disconnect();

    document.removeEventListener('shopify:section:unload', unload);
  }

  document.addEventListener('shopify:section:unload', unload);
  update();
}

  /* Enlaces por sustancia: configuración local de esta sección. */
  function readFormatLinks(root) {
    var el = root.querySelector('[data-abc-format-links]');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; }
    catch (error) { return {}; }
  }
  function formatLinksFor(drug, overrides) {
    var original = Array.isArray(drug.productLinks) ? drug.productLinks : [];
    var configured = overrides && overrides[drug.id];
    if (!Array.isArray(configured)) return original;
    var links = configured.map(function (link, index) {
      if (!link || !link.href) return null;
      var href = String(link.href).trim();
      if (!href) return null;
      try {
        var url = new URL(href, window.location.href);
        if (['http:', 'https:', 'mailto:', 'tel:'].indexOf(url.protocol) < 0) return null;
      } catch (error) { return null; }
      var label = String(link.label || '').trim();
      if (!label) label = (original[index] && original[index].label) || 'Ver formato ' + (index + 1);
      return { label: label, href: href };
    }).filter(Boolean);
    return links.length ? links : original;
  }

  /* ---------- Directorio de sustancias ---------- */
  function initExplorer(root) {
    var box = root.querySelector('[data-abc-explorer]');
    var drugs = window.KABLA_ABC_DRUGS || [];
    var formatLinkOverrides = readFormatLinks(root);
    var substanceEditor = {};
    var editorConfig = root.querySelector('[data-abc-substance-editor]');
    if (editorConfig) {
      try { substanceEditor = JSON.parse(editorConfig.textContent) || {}; } catch (error) {}
    }

    if (!box || !drugs.length) return;
    var rowsEl = box.querySelector('[data-abc-rows]');
    var input = box.querySelector('[data-abc-search]');
    var samhsa = box.querySelector('[data-abc-samhsa]');
    var sortSel = box.querySelector('[data-abc-sort]');
    var toggleAllBtn = box.querySelector('[data-abc-toggle-all]');
    var countEl = box.querySelector('[data-abc-count]');
    var toast = box.querySelector('[data-abc-toast]');
    var profile = root.querySelector('[data-abc-profile]');
    var waPhone = root.getAttribute('data-wa-phone') || '';
    var waText = root.getAttribute('data-wa-text') || 'Hola, quiero cotizar un perfil de drogas Certum con:';
    var st = { q: '', cats: [], samhsa: false, sort: 'alpha', open: [], sel: [] };

    function filtered() {
      var term = norm(st.q.trim());
      return drugs.filter(function (d) {
        var hay = d.search + ' ' + d.sections.map(function (s) { return s.items.map(function (x) { return x.value; }).join(' '); }).join(' ');
        return (!term || norm(hay).indexOf(term) >= 0) && (!st.cats.length || st.cats.indexOf(d.categoryKey) >= 0) && (!st.samhsa || d.samhsa);
      }).sort(function (a, b) {
        var n = a.name.localeCompare(b.name, 'es');
        if (st.sort === 'short') return a.maxDays - b.maxDays || n;
        if (st.sort === 'long') return b.maxDays - a.maxDays || n;
        return n;
      });
    }
    function bar(d) {
      var w = Math.max(18, Math.min(100, 13 + (Math.log1p(d.maxDays) / Math.log(31)) * 87));
      return '<div class="detection"><div class="detect-track cat-' + d.categoryKey + '"><span style="--bar-width:' + w + '%"></span></div><span>' + esc(d.window) + (d.windowRef ? '<sup>†</sup>' : '') + '</span></div>';
    }
    function detail(d, sel) {
  var h = '<div class="drug-detail"><div class="detail-grid">';

  d.sections.forEach(function (s, i) {
    h +=
      '<section class="detail-card">' +
        '<div class="detail-heading">' +
          '<span>' + String(i + 1).padStart(2, '0') + '</span>' +
          '<h4>' + esc(s.title) + '</h4>' +
          (
            i === 0
              ? '<button type="button" class="icon-button" data-copy="' +
                  esc(d.id) +
                  '" aria-label="Copiar enlace">' +
                  icon('copy', 17) +
                '</button>'
              : ''
          ) +
        '</div>' +
        '<dl>' +
          s.items.map(function (it) {
            return (
              '<div>' +
                '<dt>' + esc(it.label) + '</dt>' +
                '<dd>' + esc(it.value) + '</dd>' +
              '</div>'
            );
          }).join('') +
        '</dl>' +
      '</section>';
  });

  h +=
    '<aside class="product-card">' +
      '<span class="product-kicker">Disponible en Certum</span>' +
      '<h4>Elige el formato</h4>' +
      '<nav class="format-picker" aria-label="Formatos disponibles para ' +
        esc(d.name) + '">' +
        formatLinksFor(d, formatLinkOverrides).map(function (link) {
          return (
            '<a class="format-option" href="' + esc(link.href) + '">' +
              '<span>' + esc(link.label) + '</span>' +
              icon('arrow', 15) +
            '</a>'
          );
        }).join('') +
      '</nav>' +
    '</aside>' +
    '</div></div>';

  return h;
}
    function quote(d) {
      if (!waPhone) return d.quoteLink;
      return 'https://api.whatsapp.com/send?phone=' + waPhone + '&text=' + encodeURIComponent('Hola, quiero cotizar una prueba Certum para ' + d.name + ' (' + d.sig + ').');
    }
    function render() {
      var list = filtered();
      if (countEl) countEl.textContent = list.length;
      if (!list.length) {
        rowsEl.innerHTML = '<div class="empty-state"><span>' + icon('search', 27) + '</span><h3>Ninguna sustancia coincide</h3><p>Revisa la ortografía o quita los filtros. Kabla maneja más pruebas de las que aparecen aquí.</p><button type="button" class="abc-btn abc-btn-secondary" data-clear>Quitar filtros</button></div>';
      } else {
        rowsEl.innerHTML = list.map(function (d) {
          var open = st.open.indexOf(d.id) >= 0, sel = st.sel.indexOf(d.sig) >= 0;
          var chips = d.formats.slice(0, 2).map(function (x) { return '<span>' + esc(x.replace(' (dip card)', '')) + '</span>'; }).join('') + (d.formats.length > 2 ? '<span>+' + (d.formats.length - 2) + '</span>' : '');
          return '<article class="drug-row' + (open ? ' is-open' : '') + '" id="' + d.id + '" ' + ((substanceEditor[d.id] || {}).attributes || '') + '><div class="drug-summary">' +
            '<button type="button" class="drug-name" data-toggle="' + d.id + '" aria-expanded="' + open + '"><span class="category-dot cat-' + d.categoryKey + '"></span><span><strong>' + esc(d.name) + '</strong><small>' + esc(d.sig) + ' · ' + esc(d.category) + '</small></span></button>' +
            '<div data-label="Ventana en orina">' + bar(d) + '</div>' +
            '<div class="data-text" data-label="Corte prueba rápida">' + esc(d.cut) + '</div>' +
            '<div class="data-text" data-label="Referencia SAMHSA 2026"><span class="samhsa-badge' + (d.samhsa ? '' : ' muted') + '">' + (d.samhsa ? 'SAMHSA' : 'No federal') + '</span>' + esc(d.samhsaRef) + '</div>' +
            '<div class="format-chips" data-label="Formatos">' + chips + '</div>' +
            '<button type="button" class="drug-expand" data-toggle="' + esc(d.id) + '" aria-expanded="' + open + '" aria-label="' + (open ? 'Cerrar ficha de ' : 'Abrir ficha de ') + esc(d.name) + '">' + icon('chevron') + '</button>' +
            '</div>' + (open ? detail(d, sel) : '') + '</article>';
        }).join('');
      }
      if (toggleAllBtn) toggleAllBtn.textContent = (st.open.length === list.length && list.length) ? 'Cerrar todas' : 'Abrir todas las fichas';
      renderProfile();
    }
    function renderProfile() {
      if (!profile) return;
      if (!st.sel.length) { profile.hidden = true; profile.innerHTML = ''; return; }
      var sd = st.sel.map(function (s) { return drugs.filter(function (d) { return d.sig === s; })[0]; }).filter(Boolean);
      var fmt = [['panel', 'Panel (dip card)'], ['cup', 'Simple Cup'], ['sal', 'Saliva Cup']];
      var full = fmt.filter(function (f) { return sd.every(function (d) { return d.formatKeys.indexOf(f[0]) >= 0; }); }).map(function (f) { return f[1]; });
      var parts = fmt.map(function (f) { return [f[1], sd.filter(function (d) { return d.formatKeys.indexOf(f[0]) >= 0; }).length]; }).filter(function (p) { return p[1] > 0 && p[1] < st.sel.length; });
      var rec = full.length ? 'Todo tu perfil cabe en: ' + full.join(' o ') + '. Te confirmamos la combinación exacta disponible.'
        : 'Ningún formato múltiple cubre todo. ' + parts.map(function (p) { return p[0] + ' cubre ' + p[1] + ' de ' + st.sel.length; }).join('; ') + '. Lo resolvemos combinando formatos o con una configuración a la medida.';
      var names = sd.map(function (d) { return d.name + ' (' + d.sig + ')'; }).join(', ');
      var wa = 'https://api.whatsapp.com/send?phone=' + (waPhone || '5218144441001') + '&text=' + encodeURIComponent(waText + ' ' + names + '. ¿Qué formato y combinación me recomiendan?');
      profile.hidden = false;
      profile.innerHTML = '<div class="abc-container profile-inner"><div class="profile-count"><span>' + st.sel.length + '</span><div><strong>Tu perfil Certum</strong><small>' + esc(rec) + '</small></div></div>' +
        '<div class="profile-tags">' + sd.map(function (d) { return '<button type="button" data-unselect="' + esc(d.sig) + '">' + esc(d.sig) + icon('x', 13) + '</button>'; }).join('') + '</div>' +
        '<div class="profile-actions"><button type="button" class="text-button" data-empty>Vaciar</button><a class="abc-btn" href="' + esc(wa) + '" target="_blank" rel="noopener">Cotizar perfil ' + icon('arrow', 17) + '</a></div></div>';
    }
    function toggleSel(sig) {
      var i = st.sel.indexOf(sig);
      if (i >= 0) st.sel.splice(i, 1); else st.sel.push(sig);
      render();
    }
    function showToast(msg) {
      if (!toast) return;
      toast.innerHTML = icon('check', 17) + esc(msg); toast.hidden = false;
      clearTimeout(toast._t); toast._t = setTimeout(function () { toast.hidden = true; }, 1800);
    }

    input && input.addEventListener('input', function () { st.q = input.value; render(); });
    samhsa && samhsa.addEventListener('change', function () { st.samhsa = samhsa.checked; render(); });
    sortSel && sortSel.addEventListener('change', function () { st.sort = sortSel.value; render(); });
    toggleAllBtn && toggleAllBtn.addEventListener('click', function () {
      var list = filtered();
      st.open = st.open.length === list.length ? [] : list.map(function (d) { return d.id; });
      render();
    });
    box.querySelectorAll('[data-cat]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-cat'), i = st.cats.indexOf(k);
        if (i >= 0) st.cats.splice(i, 1); else st.cats.push(k);
        var on = st.cats.indexOf(k) >= 0;
        b.className = on ? 'filter-chip active cat-' + k : 'filter-chip';
        b.setAttribute('aria-pressed', on);
        render();
      });
    });
    rowsEl.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-toggle]'))) {
        var id = t.getAttribute('data-toggle'), i = st.open.indexOf(id);
        if (i >= 0) st.open.splice(i, 1); else st.open.push(id);
        render();
      } else if ((t = e.target.closest('[data-select]'))) {
        toggleSel(t.getAttribute('data-select'));
      } else if ((t = e.target.closest('[data-copy]'))) {
        var url = location.href.split('#')[0] + '#' + t.getAttribute('data-copy');
        if (navigator.clipboard) navigator.clipboard.writeText(url);
        showToast('Enlace copiado');
      } else if (e.target.closest('[data-clear]')) {
        st.q = ''; st.cats = []; st.samhsa = false;
        if (input) input.value = ''; if (samhsa) samhsa.checked = false;
        box.querySelectorAll('[data-cat]').forEach(function (b) { b.className = 'filter-chip'; b.setAttribute('aria-pressed', 'false'); });
        render();
      }
    });
    profile && profile.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-unselect]'))) toggleSel(t.getAttribute('data-unselect'));
      else if (e.target.closest('[data-empty]')) { st.sel = []; render(); }
    });
    function selectSubstanceBlock(event) {
      var blockId = event.detail && event.detail.blockId;
      var id = Object.keys(substanceEditor).filter(function (key) {
        return substanceEditor[key].id === blockId;
      })[0];
      if (!id || !drugs.some(function (d) { return d.id === id; })) return;
      st.q = ''; st.cats = []; st.samhsa = false;
      if (input) input.value = '';
      if (samhsa) samhsa.checked = false;
      box.querySelectorAll('[data-cat]').forEach(function (button) {
        button.className = 'filter-chip'; button.setAttribute('aria-pressed', 'false');
      });
      if (st.open.indexOf(id) < 0) st.open.push(id);
      render();
      var row = document.getElementById(id);
      if (row) row.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
    function unloadExplorer(event) {
      if (!event.target.contains(root)) return;
      document.removeEventListener('shopify:block:select', selectSubstanceBlock);
      document.removeEventListener('shopify:section:unload', unloadExplorer);
    }
    document.addEventListener('shopify:block:select', selectSubstanceBlock);
    document.addEventListener('shopify:section:unload', unloadExplorer);
    var hash = location.hash.slice(1);
    if (drugs.some(function (d) { return d.id === hash; })) st.open = [hash];
    render();
  }

  /* ---------- Formatos Certum (pestañas + deslizamiento móvil) ---------- */
  function initFormats(root) {
    var wrap = root.querySelector('[data-abc-formats]');
    if (!wrap) return;
    var tiles = wrap.querySelector('.fx-tiles');
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('.fx-tile'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('.fx-panel'));
    var tw = wrap.querySelector('.fx-tiles-wrap');
    var hint = wrap.querySelector('.fx-swipe');
    var cur = 0;
    function show(i, scroll) {
      cur = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t, j) { t.classList.toggle('on', j === cur); t.setAttribute('aria-selected', j === cur); t.tabIndex = j === cur ? 0 : -1; });
      panels.forEach(function (p, j) {
        p.hidden = j !== cur;
        if (j === cur) { p.style.animation = 'none'; void p.offsetHeight; p.style.animation = ''; }
      });
      if (scroll && tiles.scrollWidth > tiles.clientWidth) tiles.scrollTo({ left: tabs[cur].offsetLeft - tiles.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(cur + (e.key === 'ArrowRight' ? 1 : -1), true); tabs[cur].focus(); }
      });
    });
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fx-step]');
      if (b) show(cur + parseInt(b.getAttribute('data-fx-step'), 10), true);
    });
    if (tiles && hint && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        if (reducedMotion || tiles.scrollWidth <= tiles.clientWidth) return;
        setTimeout(function () { tiles.scrollTo({ left: 60, behavior: 'smooth' }); setTimeout(function () { tiles.scrollTo({ left: 0, behavior: 'smooth' }); }, 650); }, 500);
      }, { threshold: 0.6 });
      io.observe(tiles);
      tiles.addEventListener('scroll', function () {
        if (tiles.scrollLeft > 80) hint.classList.add('hide');
        tw && tw.classList.toggle('end', tiles.scrollLeft + tiles.clientWidth >= tiles.scrollWidth - 4);
      }, { passive: true });
    }
    show(0);
  }

  /* ---------- FAQ: acordeón (una pregunta abierta a la vez, opcional) ---------- */
  function initFaq(root) {
    var list = root.querySelector('[data-abc-faq]');
    if (!list) return;
    var single = list.getAttribute('data-single') === 'true';
    var items = list.querySelectorAll('details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (single && d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-abc-root]').forEach(function (root) {
      if (root.__abc) return;
      root.__abc = true;
      initSubnav(root); initExplorer(root); initFormats(root); initFaq(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.KablaABC = { init: init };
})();